export default __webpack_public_path__ + "static/media/user.855c037a.svg";